import {
  freeBabyStuffGuide,
  freeShippingFaqPath,
  newRegistryPath,
  registryDiscountPath,
  helloBabyBoxHowToGet,
  storePath,
  storeCategoryPath,
} from 'lib/urls'
import { CONFIG, FREE_SHIPPING_THRESHOLD } from 'shared/constants'
import { Question } from '../../store/components/FrequentlyAskedQuestions/FrequentlyAskedQuestions.types'

const salePath = storeCategoryPath('sale')

export const DISCOUNTS = [
  {
    thumbnail:
      'https://images.babylist.com/image/upload/q_auto,f_auto,w_170,h_170,c_mpad/v1686776340/15_discount_yjhslj.svg',
    title: `${CONFIG.store.registryDiscountPctDisplay} Registry Discount`,
    description: `Get a ${CONFIG.store.registryDiscountPctDisplay} registry completion discount on the Babylist Shop.`,
    ctaText: 'Start Your Babylist Registry',
    ctaLink: newRegistryPath,
    detailsLink: registryDiscountPath,
  },
]

export const OFFERS = [
  {
    thumbnail:
      'https://images.babylist.com/image/upload/q_auto,f_auto,w_170,h_170,c_mpad/v1686776039/free_thumbnail_zpfo1f.svg',
    title: 'Free Babylist Hello Baby Box',
    description:
      'Create a Babylist registry today to be eligible for a free baby box full of goodies for you and baby.',
    ctaText: 'Get Freebie',
    ctaLink: newRegistryPath,
    detailsLink: helloBabyBoxHowToGet,
  },
  {
    thumbnail:
      'https://images.babylist.com/image/upload/q_auto,f_auto,w_170,h_170,c_mpad/v1686776039/free_thumbnail_zpfo1f.svg',
    title: 'Free Walmart Baby Box',
    description:
      "If you're registering for baby things at Walmart, you can get your free welcome baby box right away.",
    ctaText: 'Get Offer',
    ctaLink: 'https://walmart.cesampling.com/babybox/order',
    detailsLink: freeBabyStuffGuide,
  },
  {
    thumbnail:
      'https://images.babylist.com/image/upload/q_auto,f_auto,w_170,h_170,c_mpad/v1686776039/free_thumbnail_zpfo1f.svg',
    title: 'Free Amazon Welcome Box',
    description:
      'Get a Welcome Box gift with full, travel, and sample-size surprises for parents and baby (some restrictions apply).',
    ctaText: 'Get Offer',
    ctaLink:
      'https://www.amazon.com/gp/help/customer/display.html?nodeId=GBLXVKVYG5SBG8HF&psc=1&tag=hello-baby-20&th=1',
    detailsLink: freeBabyStuffGuide,
  },
  {
    thumbnail:
      'https://images.babylist.com/image/upload/q_auto,f_auto,w_170,h_170,c_mpad/v1686776039/free_thumbnail_zpfo1f.svg',
    title: 'Free Target Welcome Kit',
    description:
      "If you're registering for baby things at Target, you can go to your nearest Target to pick up your Baby Welcome Kit",
    ctaText: 'Get Offer',
    ctaLink:
      'https://goto.target.com/c/65668/81938/2092?u=https%3A%2F%2Fwww.target.com%2Fgift-registry%2Fcreate-baby-registry%3Fclkid%3Dc37ca1e3Nb89b11edb739c758b6771f4e%26cpng%3DPTID1%26lnm%3D81938%26afid%3DBabyList%2520Inc%26ref%3Dtgt_adv_xasd0002%23%3A~%3Atext%3DLearn%2520more-%2CFree%2520welcome%2520kit%2C-Once%2520you%2520create',
    detailsLink: freeBabyStuffGuide,
  },
  {
    thumbnail:
      'https://images.babylist.com/image/upload/q_auto,f_auto,w_170,h_170,c_mpad/v1686776039/free_thumbnail_zpfo1f.svg',
    title: 'More Free Baby Stuff',
    description:
      "From formula & diapers to postpartum recovery products, you'll only pay for shipping (or nothing!) for this stuff",
    ctaText: 'See All Offers',
    ctaLink: freeBabyStuffGuide,
    detailsLink: '',
  },
]

export const OTHER = [
  {
    thumbnail:
      'https://images.babylist.com/image/upload/q_auto,f_auto,w_170,h_170,c_mpad/v1686776226/free_shipping_bpooe8.svg',
    title: 'Free Standard Shipping',
    description: `Get free standard shipping on the best baby gear orders over $${FREE_SHIPPING_THRESHOLD} in The Babylist Shop`,
    ctaText: 'Get Free Shipping',
    ctaLink: storePath,
    detailsLink: freeShippingFaqPath,
  },
]

export const FAQS: Question[] = [
  {
    id: '1',
    question: 'Does Babylist price match with other retailers?',
    answer: `
      <p>No, we are not able to price match with other retailers. Our prices are predetermined in our partnership agreements with our vendors and we are not authorized to sell their products at a reduced price.</p>
      <br />
      <p>However, Babylist gives you the freedom to purchase your gift from anywhere you'd like. If you find an item for a better price at a different retailer, feel free to buy it there instead!</p>
    `,
  },
  {
    id: '2',
    question: 'Can I use a Buy Now, Pay Later method to purchase on Babylist?',
    answer: `
      <p>It depends on the store you want to purchase items from. The <a href="${storePath}">Babylist Shop</a> accepts Klarna and Afterpay as a form of payment.</p>
      <br />
      <p>If the items you want to purchase from your registry are sold by other retailers, they will need to offer Buy Now, Pay Later as a payment option to use it.</p>
    `,
  },
  {
    id: '3',
    question: 'What can my Babylist registry discount be used on?',
    answer: `
      <p>The <a href="${registryDiscountPath}">Babylist registry discount</a> can be used on items sold in our <a href="${storePath}">Babylist Shop</a>. The discount is one-time-use only and does not apply to gift cards, or shipping and handling fees, and cannot be used for the purchase of products from the following brands and products: Lovevery (subscription play kits), Pampers, Mockingbird, UPPAbaby, Guava Family, Nuna, Diapers, and Wipes.*</p>
      <br />
      <p>The registry discount cannot be combined with any other offer or applied to a previous purchase and is not redeemable for cash. It expires 6 months after your baby's expected arrival date. <a href="${registryDiscountPath}">You can find this information, brand exclusions and more on registry discounts here.</a></p>
      <br />
      <p>*Additional exclusions may apply.</p>
    `,
  },
  {
    id: '4',
    question: 'Does Babylist have sales?',
    answer: `
      <p>Absolutely! Our largest sales usually take place during key holidays such as Labor Day, Memorial Day, President's Day, and Black Friday/Cyber Monday. We also have marked down items on our <a href="${salePath}">Sale page</a> so be sure to check it regularly to snag great deals on a wide range of items.</p>
    `,
  },
]

export const GUIDE_SLUGS = [
  'free-baby-stuff-while-pregnant',
  'pampers-club-how-it-works',
  'how-to-save-money-on-baby-gear',
  'save-vs-splurge',
]
